import palomaBackend from "@astina/paloma-common-ui/src/services/PalomaBackend";
import { handleHttpError } from "@astina/paloma-common-ui/src/services/Alerts";
const http = palomaBackend.http;
class VensoRepository {
    async getOrderGroup(id, token) {
        try {
            const response = await http
                .get('venso/supplier/get_order_group', {
                params: { id, token },
            });
            return response.data;
        }
        catch (error) {
            return handleHttpError(error);
        }
    }
    async confirmOrderGroup(id, token) {
        try {
            const response = await http
                .post('venso/supplier/confirm_order_group', {}, {
                params: { id, token },
            });
            return response.data;
        }
        catch (error) {
            return handleHttpError(error);
        }
    }
    async updateDeliveryNoticeItem(groupId, accessToken, update) {
        try {
            const response = await http
                .post('venso/supplier/update_delivery_notice_item', update, {
                params: { groupId, token: accessToken },
            });
            return response.data;
        }
        catch (error) {
            return handleHttpError(error);
        }
    }
    async getTaxRates(groupId, token) {
        try {
            const response = await http
                .get('venso/supplier/get_tax_rates', {
                params: { groupId, token },
            });
            return response.data;
        }
        catch (error) {
            return handleHttpError(error);
        }
    }
    async addDeliveryNoticeItem(groupId, accessToken, draft) {
        try {
            const response = await http
                .post('venso/supplier/add_delivery_notice_item', draft, {
                params: { groupId, token: accessToken },
            });
            return response.data;
        }
        catch (error) {
            return handleHttpError(error);
        }
    }
    async removeDeliveryNoticeItem(groupId, accessToken, item) {
        try {
            const response = await http
                .post('venso/supplier/remove_delivery_notice_item', item, {
                params: { groupId, token: accessToken },
            });
            return response.data;
        }
        catch (error) {
            return handleHttpError(error);
        }
    }
    async saveDeliveryNoticeComment(groupId, accessToken, orderId, comment) {
        try {
            await http
                .post('venso/supplier/save_delivery_notice_comment', { orderId, comment }, {
                params: { groupId, token: accessToken },
            });
        }
        catch (error) {
            return handleHttpError(error);
        }
    }
    async getOrder(id) {
        try {
            const response = await http
                .get('venso/order/get_order', {
                params: { id },
            });
            return response.data;
        }
        catch (error) {
            return handleHttpError(error);
        }
    }
    async confirmOrderDelivery(id) {
        try {
            const response = await http
                .post('venso/order/confirm_order_delivery', {}, {
                params: { id },
            });
            return response.data;
        }
        catch (error) {
            return handleHttpError(error);
        }
    }
    async saveDeliveryReceipt(orderId, update) {
        try {
            const response = await http
                .post('venso/order/save_delivery_receipt', update, {
                params: { orderId },
            });
            return response.data;
        }
        catch (error) {
            return handleHttpError(error);
        }
    }
    async getInvoiceRequest(id, token) {
        try {
            const response = await http
                .get('venso/supplier/get_invoice_request', {
                params: { id, token },
            });
            return response.data;
        }
        catch (error) {
            return handleHttpError(error);
        }
    }
    async uploadInvoice(id, token, data) {
        try {
            const response = await http
                .post('venso/supplier/upload_invoice', data, {
                params: { id, token },
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        }
        catch (error) {
            return handleHttpError(error);
        }
    }
    async downloadControlDocument(orderId, orderNumber) {
        try {
            const response = await http.get('venso/order/download_control_document', {
                params: { orderId },
                responseType: 'blob',
            });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `Kontrollunterlage_${orderNumber}.pdf`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }
        catch (error) {
            handleHttpError(error);
        }
    }
    async uploadDeliveryReceiptImage(orderId, file) {
        try {
            const data = new FormData();
            data.append('file', file);
            const response = await http.post('venso/order/upload_delivery_image', data, {
                params: { orderId },
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                timeout: 60000,
            });
            return response.data;
        }
        catch (error) {
            return handleHttpError(error);
        }
    }
    async removeDeliveryReceiptImage(orderId, imageUri) {
        try {
            const response = await http
                .post('venso/order/remove_delivery_image', imageUri, {
                params: { orderId },
            });
            return response.data;
        }
        catch (error) {
            return handleHttpError(error);
        }
    }
}
export default new VensoRepository();
